import systemSetting from './systemSetting';

export default {
  systemSetting,
};
